import React from 'react';
import { withStyles, Typography } from '@material-ui/core';
import styles from './Footer.css';

function Footer(props) {
    return(
        <div className={props.classes.footer}>
            <Typography variant="body1">
                Copyright (©) 2020 Peter Horvath and the BIOMAG group. All rights reserved.
            </Typography>
        </div>
    );
}

export default withStyles(styles, {withTheme: true})(Footer);
